// @flow

export const setApplicationCompanies = (primary_phone: number) => {
  return { type: 'SET_APPLICATIONS', payload: primary_phone };
};

export const setActiveApplication = (application: Object) => {
  return { type: 'SET_ACTIVE_APPLICATION', payload: application };
};



// WEBPACK FOOTER //
// ./src/actions/applications/applications.js